import { CardButton } from '@jouzen/ecom-components/v3/CardButton';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import { ComponentPropsWithoutRef } from 'react';

export interface PaginatedListControlsProps extends Omit<
  ComponentPropsWithoutRef<'nav'>,
  'children'
> {
  readonly isFirstPage: boolean;
  readonly isLastPage: boolean;
  readonly onNext: () => void;
  readonly onPrev: () => void;
}

export const TEST_ID = 'paginated-list-controls';

const PaginatedListControls = ({
  isFirstPage,
  isLastPage,
  onNext,
  onPrev,
  className,
  ...props
}: PaginatedListControlsProps) => {
  const t = useTranslations();

  return (
    <nav
      data-testid={TEST_ID}
      {...props}
      className={cx(className, 'flex justify-end gap-x-4')}
    >
      <CardButton
        ariaLabel={t('back')}
        className="-scale-x-100"
        color={isFirstPage ? 'light' : 'dark'}
        disabled={isFirstPage}
        variant="arrow"
        onClick={onPrev}
      />

      <CardButton
        ariaLabel={t('next')}
        color={isLastPage ? 'light' : 'dark'}
        disabled={isLastPage}
        variant="arrow"
        onClick={onNext}
      />
    </nav>
  );
};

export default PaginatedListControls;
